import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Module } from '../model/ModuleModel';

export interface GetModulesOptions {
  locale: string;
  domain: string;
  tripStatus?: string;
  socialId?: string;
  trackerId?: string;
  sharedModuleIds?: string[];
  tripPlannerId?: string;
  linaId?: string;
  channel?: string;
}

export interface GetModulesFromLandingOptions extends GetModulesOptions {
  landingId: string;
  modulesIds: string[];
  groupedModuleId?: string;
}

@Injectable({
  providedIn: 'root'
})
export class HeadlessModuleService {
  constructor(private httpClient: HttpClient) { }

  async getModules({ locale, domain, tripStatus, socialId, trackerId, sharedModuleIds, tripPlannerId, linaId, channel }: GetModulesOptions): Promise<Module[]> {
    const params: { [key: string]: string } = {
      locale,
      domain,
      ...(tripStatus && { tripStatus }),
      ...(socialId && { socialId }),
      ...(trackerId && { trackerId }),
      ...(sharedModuleIds && sharedModuleIds.length > 0 && { ids: sharedModuleIds.join(',') }),
      ...(tripPlannerId && { tripPlannerId }),
      ...(linaId && { linaId }),
      ...(channel && { channel })
    };

    const queryString = new URLSearchParams(params).toString();
    const url = `/nymeria-gui/data/model/headlessModule?${queryString}`;

    return await this.httpClient.get(url).toPromise() as Module[];
  }

  async getModulesFromLanding({ locale, domain, tripStatus, socialId, trackerId, modulesIds, tripPlannerId, linaId, channel, landingId, groupedModuleId }: GetModulesFromLandingOptions): Promise<Module[]> {
    const params: { [key: string]: string } = {
      locale,
      domain,
      landingId,
      ...(tripStatus && { tripStatus }),
      ...(socialId && { socialId }),
      ...(trackerId && { trackerId }),
      ...(modulesIds && modulesIds.length > 0 && { ids: modulesIds.join(',') }),
      ...(tripPlannerId && { tripPlannerId }),
      ...(linaId && { linaId }),
      ...(channel && { channel }),
      ...(groupedModuleId && { groupedModuleId })
    };

    const queryString = new URLSearchParams(params).toString();
    const url = `/nymeria-gui/data/model/headlessModuleFromLanding?${queryString}`;

    return await this.httpClient.get(url).toPromise() as Module[];
  }
}
